var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topnav',{attrs:{"country":_vm.country}}),_c('div',{staticClass:"privacy"},[_c('h1',[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.body)}})]),_c('div'),_c('botfooter',{attrs:{"country":_vm.country}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }